import { CALC_PAGE_TYPES } from 'utils/calculatorUtils';
import CommonDrafts from '../../CommonViews/Drafts';
import CalcEmptyListBlock from '../../../components/CalcEmptyListBlock/CalcEmptyListBlock';

const Drafts = ({ targetWidth }) => (
  <>
    <CommonDrafts targetWidth={targetWidth} pageType={CALC_PAGE_TYPES.SUSTAINABILITY} />
  </>
);

export default Drafts;
